import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function fetchRound(recentSubjects = [], recentQuestions = []) {
  const { data } = await axios.post(`${API}/round`, {
    recent_subjects: recentSubjects,
    recent_questions: recentQuestions,
  });
  return data; // { subjects: [s1, s2], question, extracted_names: [] }
}

export async function fetchDeckStats() {
  const { data } = await axios.get(`${API}/deck/stats`);
  return data; // { phrases, questions }
}
